import { render, staticRenderFns } from "./HeaderCartPopupNew.vue?vue&type=template&id=775b2835&scoped=true&"
import script from "./HeaderCartPopupNew.vue?vue&type=script&lang=js&"
export * from "./HeaderCartPopupNew.vue?vue&type=script&lang=js&"
import style0 from "./HeaderCartPopupNew.vue?vue&type=style&index=0&id=775b2835&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775b2835",
  null
  
)

export default component.exports